export enum ContactTypeParam {
  Customer = 'isCustomer=true',
  Supplier = 'isSupplier=true',
}
